module.exports = __webpack_public_path__ + "img/Y003.66e68645.jpg";